import toCamelCaseStringUtil from 'utils/string/to-camel-case/index.js'

export default function toDomAnchorIdStringUtil (str) {
  return toCamelCaseStringUtil(str)
}
